export default {
    switch: {
        margin: 4,
        width: 44
    },
    switchTitle: {
        marginRight: 20
    },
    formGroup: {
        marginBottom: 15
    }
};
